import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '@app/environment';

export function apiBaseUrlInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const bypassInterceptor = req.url.startsWith('http') || req.url.startsWith('/assets');
  const url = bypassInterceptor
    ? req.url
    : environment.apiUrl.replace(/\/$/, '').concat('/', req.url.replace(/^\//, ''));

  return next(
    req.clone({
      url,
    }),
  );
}
